import React, { useState, useEffect } from 'react';
import PLAYER from '../playerData';
import { SHOP_ITEMS } from '../data';
import { RESOURCES } from '../content/common';
import { instantiate } from '../data';
import { ASSETS } from '../assetManifest';

function Shop({ isOpen, onClose }) {
  const [activeTab, setActiveTab] = useState('generators');
  const [inventory, setInventory] = useState(PLAYER.inventory);
  const [resources, setResources] = useState(PLAYER.resources);
  const [purchaseMessage, setPurchaseMessage] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setResources({...PLAYER.resources});
      setInventory([...PLAYER.inventory]);
    }, 100);
    return () => clearInterval(interval);
  }, []);

  const handlePurchase = (item) => {
    if (PLAYER.resources.gold < item.cost) {
      setPurchaseMessage({
        text: "Not enough gold!",
        type: "error"
      });
      setTimeout(() => setPurchaseMessage(null), 2000);
      return;
    }

    // Deduct cost
    PLAYER.resources.gold -= item.cost;

    // Handle bundle purchases
    if (item.contents) {
      Object.entries(item.contents).forEach(([itemId, quantity]) => {
        for (let i = 0; i < quantity; i++) {
          const categoryKey = findCategoryForItem(itemId);
          if (categoryKey) {
            const itemData = SHOP_ITEMS[categoryKey][itemId];
            addToInventory(itemData);
          }
        }
      });
    } else {
      // Add single item to inventory
      addToInventory(item);
    }

    setPurchaseMessage({
      text: `Purchased ${item.name}!`,
      type: "success"
    });
    setTimeout(() => setPurchaseMessage(null), 2000);
  };

  const findCategoryForItem = (itemId) => {
    for (const category in SHOP_ITEMS) {
      if (SHOP_ITEMS[category][itemId]) {
        return category;
      }
    }
    return null;
  };

  const addToInventory = (item) => {
    // Add to inventory
    const inventoryItem = instantiate({
      ...item,
      purchaseTime: Date.now()
    });
    PLAYER.inventory.push(inventoryItem);
  };

  const useInventoryItem = (index) => {
    // Remove from inventory
    PLAYER.inventory.splice(index, 1);
  };

  const renderShopItems = (category) => {
    return (
      <div className="grid grid-cols-2 gap-4">
        {Object.values(SHOP_ITEMS[category]).map(item => (
          <div 
            key={item.id}
            className="relative w-[126px] h-[194px]"
          >
            <img 
              src={ASSETS.ui.itemCardBackground.path} 
              alt="Item Background" 
              className="w-[126px] h-[194px] absolute left-0 top-0"
            />
            
            <div className="absolute w-24 h-6 left-[15px] top-[8px] text-center">
              <div className="text-white text-[10px] font-extrabold font-Asap uppercase leading-3 [text-shadow:_0px_1px_0px_rgb(0_0_0_/_1.00)]">
                {item.name}
              </div>
            </div>
            
            <div className="absolute w-[94px] h-[35px] left-[15px] top-[47px] text-center">
              <div className="text-[#161144] text-[10px] font-extrabold font-Asap uppercase leading-3">
                {item.description}
              </div>
            </div>
            
            <div className="absolute w-[47px] h-[47px] left-[39px] top-[97px] flex items-center justify-center text-3xl">
              {item.icon}
            </div>
            
            <div className="absolute w-[108px] h-[30px] left-[9px] top-[157px]">
              <img 
                src={ASSETS.ui.buyButton.path} 
                alt="Buy Button" 
                className="w-[108px] h-[30px] absolute left-0 top-0"
              />
              <div className="absolute w-[108px] h-[30px] left-0 top-0 flex items-center justify-center">
                <span className="text-white text-sm font-extrabold font-Asap uppercase mr-1 [text-shadow:_0px_1px_0px_rgb(0_0_0_/_1.00)]">
                  {item.cost}
                </span>
                <img 
                  src={RESOURCES.gold.icon} 
                  alt="Gold" 
                  className="w-4 h-4"
                  onClick={() => handlePurchase(item)}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderInventory = () => {
    if (inventory.length === 0) {
      return (
        <div className="text-center py-8 text-white text-[10px] font-extrabold font-Asap uppercase">
          Your inventory is empty. Purchase items from the shop!
        </div>
      );
    }

    return (
      <div className="grid grid-cols-2 gap-4">
        {inventory.map((item, index) => (
          <div 
            key={`${item.id}-${index}`}
            className="relative w-[126px] h-[194px]"
          >
            <img 
              src={ASSETS.ui.itemCardBackground.path} 
              alt="Item Background" 
              className="w-[126px] h-[194px] absolute left-0 top-0"
            />
            
            <div className="absolute w-24 h-6 left-[15px] top-[8px] text-center">
              <div className="text-white text-[10px] font-extrabold font-Asap uppercase leading-3 [text-shadow:_0px_1px_0px_rgb(0_0_0_/_1.00)]">
                {item.name}
              </div>
            </div>
            
            <div className="absolute w-[94px] h-[35px] left-[15px] top-[47px] text-center">
              <div className="text-[#161144] text-[10px] font-extrabold font-Asap uppercase leading-3">
                {item.description}
              </div>
            </div>
            
            <div className="absolute w-[47px] h-[47px] left-[39px] top-[97px] flex items-center justify-center text-3xl">
              {item.icon}
            </div>
            
            <div className="absolute w-[108px] h-[30px] left-[9px] top-[157px]">
              <img 
                src={ASSETS.ui.buyButton.path} 
                alt="Use Button" 
                className="w-[108px] h-[30px] absolute left-0 top-0"
              />
              <div 
                className="absolute inset-0 flex items-center justify-center text-white text-sm font-extrabold font-Asap uppercase leading-3 [text-shadow:_0px_1px_0px_rgb(0_0_0_/_1.00)]"
                onClick={() => useInventoryItem(index)}
              >
                USE
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70">
      <div className="relative w-[345px] h-[438px]">
        <img 
          src={ASSETS.ui.shopBackground.path} 
          alt="Shop Background" 
          className="w-[345px] h-[438px] absolute left-0 top-0"
        />
        
        <div className="w-[122px] h-[39px] absolute left-[107px] top-[15px] text-center text-[#efbb57] text-xl font-extrabold font-Asap uppercase [text-shadow:_0px_4px_4px_rgb(0_0_0_/_0.25)]">
          SHOP
        </div>
        
        <img 
          src={ASSETS.ui.closeButton.path} 
          alt="Close" 
          className="w-3.5 h-4 absolute left-[292px] top-[26px] cursor-pointer"
          onClick={onClose}
        />
        
        <div className="absolute w-[345px] h-[60px] left-0 top-[54px]">
          <img 
            src={ASSETS.ui.shopButtonBar.path} 
            alt="Button Bar" 
            className="w-[345px] h-[60px] absolute left-0 top-0"
          />
          
          <div className="absolute w-24 h-[33px] left-[6px] top-[18px] cursor-pointer" onClick={() => setActiveTab('generators')}>
            <img 
              src={activeTab === 'generators' ? ASSETS.ui.selectedButton.path : ASSETS.ui.unselectedButton.path} 
              alt="Generators Button" 
              className="w-24 h-[33px] absolute left-0 top-0"
            />
            <div className="absolute w-[82px] h-[26px] left-[7px] top-[4px] text-center text-white text-xs font-black font-Asap uppercase [text-shadow:_0px_1px_0px_rgb(0_0_0_/_1.00)]">
              GENERATORS
            </div>
          </div>
          
          <div className="absolute w-24 h-[33px] left-[120px] top-[18px] cursor-pointer" onClick={() => setActiveTab('bundles')}>
            <img 
              src={activeTab === 'bundles' ? ASSETS.ui.selectedButton.path : ASSETS.ui.unselectedButton.path} 
              alt="Bundles Button" 
              className="w-24 h-[33px] absolute left-0 top-0"
            />
            <div className="absolute w-[82px] h-[26px] left-[5px] top-[4px] text-center text-white text-xs font-black font-Asap uppercase [text-shadow:_0px_1px_0px_rgb(0_0_0_/_1.00)]">
              BUNDLES
            </div>
          </div>
          
          <div className="absolute w-24 h-[33px] left-[229px] top-[18px] cursor-pointer" onClick={() => setActiveTab('inventory')}>
            <img 
              src={activeTab === 'inventory' ? ASSETS.ui.selectedButton.path : ASSETS.ui.unselectedButton.path} 
              alt="Inventory Button" 
              className="w-24 h-[33px] absolute left-0 top-0"
            />
            <div className="absolute w-[82px] h-[26px] left-[5px] top-[4px] text-center text-white text-xs font-black font-Asap uppercase [text-shadow:_0px_1px_0px_rgb(0_0_0_/_1.00)]">
              INVENTORY
            </div>
          </div>
        </div>
        
        {/* Purchase message */}
        {purchaseMessage && (
          <div 
            className={`absolute left-1/2 top-[120px] transform -translate-x-1/2 p-3 rounded-lg text-center ${
              purchaseMessage.type === 'error' ? 'bg-red-600' : 'bg-green-600'
            }`}
          >
            {purchaseMessage.text}
          </div>
        )}
        
        {/* Content */}
        <div className="absolute left-[22px] top-[130px] overflow-y-auto max-h-[280px] p-2">
          {activeTab === 'inventory' 
            ? renderInventory()
            : renderShopItems(activeTab)
          }
        </div>
      </div>
    </div>
  );
}

export default Shop;
